/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */

import React, {FC, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {FormControl, InputLabel, MenuItem, Select} from '@material-ui/core';
import {observer} from 'mobx-react';
import {IEntityFieldProps} from 'icerockdev-admin-toolkit';
import {toJS} from "mobx";

type IProps = IEntityFieldProps & {};

const OrderReferenceSelect: FC<IProps> = observer(
  ({label, value, handler, error, isEditing, onClick, options}) => {
    // noinspection TypeScriptValidateTypes
    const ref = useRef<HTMLLabelElement>(null);

    const listData = useMemo<Record<string, { fullName: string; disabled: boolean }>>(
      () => {
        return options && options.referenceData && Object.keys(options.referenceData).map((id) => {
          const fullName = options.referenceData[id]?.fullName ?? options.referenceData[id]
          const isActive = options.referenceData[id]?.isActive ?? true
          return {id, fullName, disabled: !isActive}
        }).reduce((obj, item) => (
          {...obj, [item.id]: {fullName: item.fullName, disabled: item.disabled}}),
          {}
        ) || {}
      },
      [options]
    )

    const onChange = useCallback(
      (event) => {
        if (!handler) return;
        handler(event.target.value);
      },
      [value, handler]
    );

    const [labelWidth, setLabelWidth] = useState(0);

    useEffect(() => {
      setLabelWidth((ref.current && ref.current.clientWidth) || 0);
    }, [ref.current]);

    return isEditing ? (
      <FormControl variant="outlined">
        <InputLabel htmlFor={label} error={!!error} style={{whiteSpace: 'nowrap'}} ref={ref}>
          {label}
        </InputLabel>

        <Select
          variant="outlined"
          id={label}
          name={label}
          label={label}
          value={!value ? '' : value}
          onChange={onChange}
          error={!!error}
          inputProps={{className: 'select'}}
          labelWidth={labelWidth}
          style={{minWidth: labelWidth + 40}}
        >
          <MenuItem value="">...</MenuItem>

          {Object.keys(listData).map((id) => (
            <MenuItem key={id} value={id} disabled={listData[id].disabled}>
              {listData[id].fullName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ) : (
      <div onClick={onClick}>
        {(listData[value]?.fullName) || (
          <div>&nbsp;</div>
        )}
      </div>
    );
  }
);

export {OrderReferenceSelect};
